import { Temporal } from "@js-temporal/polyfill";
import { MaterielAdduction } from "./materiel-adduction";
import { PrelevementAir } from "./prelevement-air";
import { AutoMap } from "@automapper/classes";

export class MesureAdduction {
    @AutoMap()
    Code!: string;
    @AutoMap()
    Date!: Temporal.PlainDate;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    SamplingID!: number;
    @AutoMap()
    Observation!: string;
    @AutoMap()
    AppareilMesure!: string;

    /** 3 Max  */
    @AutoMap(() => [MaterielAdduction])
    MaterielAdductionAirList: MaterielAdduction[] = [];

    /** 5 Max  */
    @AutoMap(() => [PrelevementAir])
    PrelevementAirList: PrelevementAir[] = [];
    @AutoMap()
    IsCancelled: boolean = false;
    @AutoMap()
    Position!: number;
}